var map = {
	"./60352567-10157139616684666-7120782956150390784-o_orig.jpg": 6001,
	"./61704404-10157035757015491-7088747495169196032-o_orig.jpg": 4868,
	"./61813169-410640319661042-5560445316316004352-n_orig.jpg": 621,
	"./62318982-688281024960270-8985133525250342912-n_orig.jpg": 1169,
	"./62419939-10157035752190491-336501324612894720-o.jpg": 7851,
	"./62419939-10157035752190491-336501324612894720-o_orig.jpg": 4418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5128;